import { render, staticRenderFns } from "./ProductCardCompare.vue?vue&type=template&id=4172d8e8&scoped=true"
import script from "./ProductCardCompare.vue?vue&type=script&lang=js"
export * from "./ProductCardCompare.vue?vue&type=script&lang=js"
import style0 from "./ProductCardCompare.vue?vue&type=style&index=0&id=4172d8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4172d8e8",
  null
  
)

export default component.exports